import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.closeToSeniorCoach');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Close To Senior Coach')}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxOrderingEntities} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('qualifyingPoints', 'Qualifying Points')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxQualifyingPoints} />}
        />
      </Gutter>
    </View>
  );
};
